import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'user-details';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const INITIALIZED = `${NAMESPACE}/INITIALIZED`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const USER_GET = createApiNamespacedConstants('USER_GET');
export const USER_GET_ACCESS_KEY = createApiNamespacedConstants('USER_GET_ACCESS_KEY');
export const USER_DEACTIVATE = createApiNamespacedConstants('USER_DEACTIVATE');
export const USER_REACTIVATE = createApiNamespacedConstants('USER_REACTIVATE');
export const USER_RESET_PASSWORD = createApiNamespacedConstants('USER_RESET_PASSWORD');
export const REMOVE_TEAM_MEMBERSHIP = createApiNamespacedConstants('REMOVE_TEAM_MEMBERSHIP');
export const ADD_TEAM_MEMBERSHIP = createApiNamespacedConstants('ADD_TEAM_MEMBERSHIP');
export const ACTIVITY_GET = createApiNamespacedConstants('ACTIVITY_GET');
export const TUNNELS_GET = createApiNamespacedConstants('TUNNELS_GET');
export const RESET_ACCESS_KEY = createApiNamespacedConstants('RESET_ACCESS_KEY');
export const STOP_TUNNEL = createApiNamespacedConstants('STOP_TUNNEL');
export const CHANGE_EMAIL = createApiNamespacedConstants('CHANGE_EMAIL');
export const CHANGE_PASSWORD = createApiNamespacedConstants('CHANGE_PASSWORD');
export const CHANGE_ASSIGNED_TEAMS = createApiNamespacedConstants('CHANGE_ASSIGNED_TEAMS');
